import React, { forwardRef, useRef, useState, useMemo } from 'react';
import { DatePicker } from 'antd';
import cn from 'classnames';
import styles from './DateRange.module.scss';

const { RangePicker } = DatePicker;

const DateRange = forwardRef(function DateRange(
  {
    containerKey = 'rangePickerContainer',
    renderButton,
    rootClassName,
    format = 'DD.MM.YYYY',
    onChange,
    value,
    renderFooter,
    visible,
    separator = '',
    ...props
  },
  ref
) {
  const hasVisible = useMemo(() => typeof visible === 'boolean', [visible]);

  const [open, setOpen] = useState(hasVisible ? visible : false);

  const closePicker = () => {
    setOpen(false);
  };

  const wasOpenOnMouseDownOpenRef = useRef(open);
  const handleButtonMouseDownCapture = () => {
    wasOpenOnMouseDownOpenRef.current = open;
  };

  const handleButtonClick = () => {
    if (!hasVisible) {
      const wasOpen = wasOpenOnMouseDownOpenRef.current;
      setOpen(!wasOpen);
    }
  };

  const handleChange = (dates, dateStrings) => {
    if (typeof onChange === 'function') {
      onChange(dates, dateStrings);
    }

    if (!hasVisible) {
      closePicker();
    }
  };

  const handleOpenChange = (status) => {
    if (!hasVisible) {
      setOpen(status);
    }
  };

  return (
    <div ref={ref} className={cn(styles.root, rootClassName)} id={containerKey}>
      <div onMouseDownCapture={handleButtonMouseDownCapture}>
        {renderButton({ onClick: handleButtonClick, open })}
      </div>

      <RangePicker
        onOpenChange={handleOpenChange}
        {...props}
        open={open}
        className={styles.rangePicker}
        getCalendarContainer={() => document.getElementById(containerKey)}
        format={format}
        separator={separator}
        value={value}
        onChange={handleChange}
        dropdownClassName={styles.rangePickerDropdown}
        renderExtraFooter={
          typeof renderFooter === 'function'
            ? () => renderFooter({ onClose: closePicker })
            : undefined
        }
      />
    </div>
  );
});

export default DateRange;
